import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { VerificarQuestoesSegurancaCandidato } from '@app/models/sisrh.model';
import { SisrhService } from '@app/services/sisrh.service';
import { AppUtil } from '@app/utils/app.util';

@Component({
  selector: 'app-perguntas-seguranca',
  templateUrl: './perguntas-seguranca.component.html'
})
export class PerguntasSegurancaComponent implements OnInit {

  @Input() cpf: string;
  @Output() eePerguntasSeguranca = new EventEmitter<any>();

  enviando = false;
  fgPerguntasSeguranca: FormGroup;

  constructor(
    private fb: FormBuilder,
    private sisrhService: SisrhService
  ) { }

  ngOnInit() {

    AppUtil.focalizarCampo('idDataNascimento');

    this.fgPerguntasSeguranca = this.fb.group({
      cpf: this.cpf,
      dataNascimento: ['', [Validators.required]],
      primeiroNomeMae: ['', [Validators.required]]
    });

  }

  get c() {

    return this.fgPerguntasSeguranca.controls;

  }

  responder() {

    this.enviando = true;

    if (this.fgPerguntasSeguranca.invalid) {
      return;
    }

    const oPerguntasSeguranca: VerificarQuestoesSegurancaCandidato = Object.assign({}, this.fgPerguntasSeguranca.value);
    oPerguntasSeguranca.cpf = AppUtil.removerSinais(oPerguntasSeguranca.cpf);

    this.fgPerguntasSeguranca.disable();

    this.sisrhService
      .verificarQuestoesSeguranca(oPerguntasSeguranca)
      .subscribe(
        x => {
          if (!x.success) {
            this.ok();
          }
          this.eePerguntasSeguranca.emit({
            ok: true,
            ...x
          });
        },
        e => {
          this.eePerguntasSeguranca.emit(e);
          this.ok();
        }
      );

  }

  ok() {

    this.fgPerguntasSeguranca.enable();
    this.enviando = false;
    AppUtil.focalizarCampo('idDataNascimento');

  }

}
